import { render } from "./ProductDeletionDialog.vue?vue&type=template&id=050343e5"
import script from "./ProductDeletionDialog.vue?vue&type=script&lang=js"
export * from "./ProductDeletionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__